<template>
  <v-expansion-panels accordion>
    <v-expansion-panel class="elevation-2">
      <v-expansion-panel-header class="px-4 panel-header">
        <div class="d-flex align-center">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <v-btn @click.stop="fetchAditionals" :loading="isLoading" v-on="on" v-bind="attrs" small color="primary">
                <v-icon>mdi-reload</v-icon>
              </v-btn>
            </template>
            Recarregar listagem
          </v-tooltip>
          <v-icon size="20" class="mx-2"> mdi-information-outline </v-icon>
          <h4>{{ expandTitle }}</h4>
        </div>
        <template v-slot:actions>
          <v-icon color="black"> mdi-chevron-down </v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="mx-4 mt-4 d-flex flex-column">
          <v-data-table
            v-model="selectedAditionals"
            :items="filteredAditionalRelated"
            :headers="tableHeaders"
            :height="unselectedAditionalsTableHeight"
            :items-per-page="filteredAditionalRelated.length"
            @change="$emit('input', value)"
            :loading="isLoading"
            loading-text="Carregando..."
            no-data-text="Sem adicionais para vincular"
            item-key="id"
            :show-select="filteredAditionalRelated.length > 0"
            hide-default-footer
          >
            <template v-slot:[`item.boardingId`]="{ item }">
              {{ getStopOrBoardingId(item.boardingId) }}
            </template>
            <template v-slot:[`item.stopId`]="{ item }">
              {{ getStopOrBoardingId(item.stopId) }}
            </template>
            <template v-slot:[`item.price`]="{ item }">
              {{ transformPrice(item.price) }}
            </template>
            <template v-slot:[`item.isDiscount`]="{ item }">
              {{ getAditionalIsDiscount(item.isDiscount) }}
            </template>
            <template v-slot:[`item.additionalDate`]="{ item }">
              {{ getAdditionalDate(item.additionalDate) }}
            </template>
            <template v-slot:[`item.justification`]="{ item }">
              {{ getAditionalJustification(item.justification) }}
            </template>
          </v-data-table>
          <div class="my-4 d-flex justify-end">
            <v-btn @click="addRelatedAditionals()" :disabled="selectedAditionals.length == 0" color="success">
              Adicionar à ordem de pagamento
            </v-btn>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import maskPrice from '@/utils/maskPrice';
import { mapActions, mapGetters } from 'vuex';
export default {
  props: {
    applicationUserId: {
      default: null,
      type: String
    },
    isTranshipmentAditionals: {
      default: false,
      type: Boolean
    },
    creditsOnly: {
      default: false,
      type: Boolean
    },
    value: {
      default: () => [],
      type: Array
    },
    aditionalRelated: {
      default: () => [],
      type: Array
    },
    selectedAdditionals: {
      default: () => [],
      type: Array
    }
  },

  data: () => ({
    isLoading: false,
    selectedAditionals: [],
    aditionals: []
  }),

  computed: {
    tableHeaders() {
      return [
        {
          value: 'boardingId',
          text: 'ID DA PARADA'
        },
        {
          value: 'isDiscount',
          text: 'TIPO'
        },
        {
          value: 'price',
          text: 'VALOR'
        },
        {
          value: 'additionalDate',
          text: 'DATA DE CRIAÇÃO'
        },
        {
          value: 'justification',
          text: 'JUSTIFICATIVA'
        },
        {
          value: 'observation',
          text: 'OBSERVAÇÃO'
        }
      ];
    },

    panelUserLabel() {
      return this.isTranshipmentAditionals ? 'transbordo' : 'entregador direto';
    },

    filteredAditionalRelated() {
      const aditionalsIds = this.aditionalRelated.map((aditional) => aditional.id);
      return this.aditionals.filter((aditional) => !aditionalsIds.includes(aditional.id));
    },

    unselectedAditionalsTableHeight() {
      const hasMoreThanFiveAditional = this.filteredAditionalRelated.length > 5;
      return hasMoreThanFiveAditional ? '250' : '';
    },

    expandTitle() {
      const hasRelatedAditionals = this.filteredAditionalRelated.length > 0;
      return hasRelatedAditionals ? 'Existem adicionais previamente vinculado' : 'Sem adicionais vinculados';
    },

    ...mapGetters('NfeStore', ['getJustificationsById'])
  },

  watch: {
    applicationUserId: {
      async handler(applicationUserId) {
        this.aditionals = [];
        if (applicationUserId !== null) {
          this.fetchAditionals();
        }
      }
    },
    selectedAdditionals: {
      async handler(selectedAdditionals) {
        if (selectedAdditionals !== []) {
          this.fetchAditionals();
        }
      }
    }
  },

  created() {
    this.fetchAditionals();
  },

  methods: {
    ...mapActions('AccountsStore', ['getRelatedAditionals']),
    async fetchAditionals() {
      try {
        this.isLoading = true;
        if (this.applicationUserId !== null) {
          this.aditionals = await this.getRelatedAditionals(this.applicationUserId);

          if (this.creditsOnly) {
            this.aditionals = this.aditionals.filter((aditional) => !aditional.isDiscount);
          }
          // Filtrar os additionalDto que não estão associados ao userDto
          if (this.selectedAdditionals) {
            this.aditionals = this.aditionals.filter(
              (aditional) => !this.selectedAdditionals.some((userAditional) => userAditional.id === aditional.id)
            );
          }

          this.$emit('input', this.aditionals);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    addRelatedAditionals() {
      const newAditionals = this.selectedAditionals.map((aditional) => {
        const justification = aditional.justification;
        return { ...aditional, justification, isRelatedAditional: true };
      });

      this.$emit('clickAddAditionals', newAditionals);
      this.selectedAditionals = [];
    },

    getStopOrBoardingId(stopOrBoardingId) {
      return stopOrBoardingId ? stopOrBoardingId : '-';
    },
    getAditionalIsDiscount(isDiscount) {
      return isDiscount ? 'Débito' : 'Crédito';
    },
    getAdditionalDate(additionalDate) {
      const [year, month, day] = additionalDate.slice(0, 10).split('-');
      return `${day}/${month}/${year}`;
    },
    getAditionalJustification(justification) {
      return typeof justification === 'string' ? justification : justification.name;
    },
    transformPrice(price) {
      return maskPrice(price);
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-header {
  background: $--color-table-offset;
}
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
